import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import client from './client';

const queryFn = client.queryParkingRecords;

type Response = Awaited<ReturnType<typeof queryFn>>;
type Params = Pick<
  Parameters<typeof queryFn>[0],
  'parkinglot_id' | 'vehicle_type'
> & { plateNumber: string };

export const useSearchParkingRecords = (
  params: Params,
  options: Omit<UseQueryOptions<Response>, 'queryFn' | 'queryKey'> = {},
) => {
  const plate_number_fuzzy = (params?.plateNumber ?? '').split('-')?.[1];

  const { data, ...query } = useQuery({
    ...options,
    queryKey: ['search-parking-record', params],
    queryFn: () => {
      const { parkinglot_id, vehicle_type } = params;

      return queryFn({
        parkinglot_id,
        vehicle_type,
        plate_number_fuzzy,
      });
    },
    select: (response: Response) => {
      return (response.data?.data ?? []).filter(
        ({ plate_number }) => plate_number === params.plateNumber,
      );
    },
    enabled: options.enabled && !!plate_number_fuzzy,
  });

  return { ...query, searchedParkingRecords: data };
};
